import { Classes, Dialog } from "@blueprintjs/core";
import { FGTextInput, FieldGroup } from "nsitools-react";
import * as React from "react";
import styled from "styled-components";
import * as Yup from "yup";

import { LieuFormationFichierApi, LieuFormationFichierDto } from "../../../../../api";
import { FGWalterSelectInput, SmallFormGenerator } from "../../../../../components";
import { useApiService, useCrudApi, useTl } from "../../../../../hooks";
import { useReferential } from "../../../../../hooks/useReferential";
import { ETLCodes } from "../../../../../locales";

const StyledDialog = styled(Dialog)`
  width: 600px;
  height: auto;
  background-color: white;
`;

export interface ILieuFormationDocumentEditDialogProps {
  idlieuFormationFichier: number;
  onClose: (refresh?: boolean) => void;
}

export const LieuFormationDocumentEditDialog: React.FunctionComponent<ILieuFormationDocumentEditDialogProps> = ({
  idlieuFormationFichier,
  onClose
}) => {
  const { t } = useTl();
  const api = useApiService(LieuFormationFichierApi);

  const { data, loading, saveItem, saving, validationErrors } = useCrudApi(
    React.useMemo(
      () => ({
        getApiFn: () => {
          return api.lieuFormationFichierGetLieuFormationFichier({ id: idlieuFormationFichier });
        },
        saveApiFn: async (d: LieuFormationFichierDto) => {
          return api.lieuFormationFichierSaveLieuFormationFichier({ LieuFormationFichierDto: d });
        },
        onSaved: () => onClose(true)
      }),
      [api, idlieuFormationFichier, onClose]
    )
  );

  const FormSchema = React.useMemo(
    () =>
      Yup.object().shape({
        idtypeLieuFormationFichier: Yup.number()
          .nullable()
          .required(t(ETLCodes.Required))
      }),
    [t]
  );

  const [typesLieuFormationFichier, tLoading] = useReferential(a => a.referentialGetTypesLieuFormationFichier());

  return (
    <StyledDialog title={t(ETLCodes.UploadFichier)} isOpen={!!idlieuFormationFichier} onClose={() => onClose(false)}>
      <div className={Classes.DIALOG_BODY}>
        <SmallFormGenerator
          initialValues={data}
          onSubmit={saveItem}
          editMode={true}
          validationSchema={FormSchema}
          onCancel={() => onClose(false)}
          showDeleteButton={false}
          saving={saving}
          loading={loading}
          validationErrors={validationErrors}
        >
          <FieldGroup>
            <FGTextInput name="fileName" label={t(ETLCodes.Fichier)} readonly />
            <FGWalterSelectInput
              name="idtypeLieuFormationFichier"
              label={t(ETLCodes.Type)}
              items={typesLieuFormationFichier}
              loading={tLoading}
            />
          </FieldGroup>
        </SmallFormGenerator>
      </div>
    </StyledDialog>
  );
};
